import { BoardTypeDto } from '@vatos-pas/common';

import { BoardFormValues } from '../containers';

type ValidationErrors = Record<string, string[] | undefined>;

const NAME_MAX_LENGTH = 100;
const SHORT_NAME_MAX_LENGTH = 50;
const EXTERNAL_ID_MAX_LENGTH = 100;

export const validateBoard = async (
  values: BoardFormValues,
  existingBoards: BoardTypeDto[],
  currentBoardId?: string | number,
): Promise<ValidationErrors> => {
  const errors: ValidationErrors = {};

  // Name
  if (!values.name) {
    errors.name = ['Name is required.'];
  } else if (values.name.length > NAME_MAX_LENGTH) {
    errors.name = ['Name must be shorter than or equal to 100 characters.'];
  } else {
    const duplicate = existingBoards.find(
      board => board.id !== currentBoardId && board.name === values.name,
    );
    if (duplicate) {
      errors.name = ['This name is already in use. Please try another.'];
    }
  }

  // Short name
  if (!values.shortName) {
    errors.shortName = ['Short name is required.'];
  } else if (values.shortName.length > SHORT_NAME_MAX_LENGTH) {
    errors.shortName = [
      'Short name must be shorter than or equal to 50 characters',
    ];
  } else {
    const duplicate = existingBoards.find(
      board =>
        board.id !== currentBoardId && board.shortName === values.shortName,
    );
    if (duplicate) {
      errors.shortName = [
        'This short name is already in use. Please try another.',
      ];
    }
  }

  // External ID
  if (!values.externalId) {
    errors.externalId = ['External ID is required.'];
  } else if (values.externalId.length > EXTERNAL_ID_MAX_LENGTH) {
    errors.externalId = [
      'External ID must be shorter than or equal to 100 characters.',
    ];
  }

  // Payable Resource Type
  if (!values.payableResourceTypes?.length) {
    errors.payableResourceTypes = ['Payable Resource Types is required.'];
  }

  return errors;
};
